/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumnpercredit4Inputs */

const en_aicostscolumnpercredit4 = /** @type {(inputs: Aicostscolumnpercredit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per credit`)
};

const de_aicostscolumnpercredit4 = /** @type {(inputs: Aicostscolumnpercredit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je Credit`)
};

/**
* | output |
* | --- |
* | "Per credit" |
*
* @param {Aicostscolumnpercredit4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumnpercredit4 = /** @type {((inputs?: Aicostscolumnpercredit4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumnpercredit4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumnpercredit4(inputs)
	return de_aicostscolumnpercredit4(inputs)
});
export { aicostscolumnpercredit4 as "aiCostsColumnPerCredit" }